type ShimmerProps = {
    count?: number;
    type?: 'card' | 'text' | 'avatar' | 'table';
};

export const Shimmer = ({count = 3, type = 'card'}: ShimmerProps) => {
    const items = Array.from({length: count}, (_, i) => i);

    if (type === 'card') {
        return (
            <div className="shimmer-container" data-testid="shimmer">
                {items.map((i) => (
                    <div key={i} className="shimmer shimmer-card" />
                ))}
            </div>
        );
    }

    if (type === 'text') {
        return (
            <div className="shimmer-container">
                {items.map((i) => (
                    <div
                        key={i}
                        className="shimmer shimmer-text"
                        style={{width: `${60 + Math.random() * 30}%`}}
                    />
                ))}
            </div>
        );
    }

    if (type === 'avatar') {
        return (
            <div className="shimmer-container shimmer-row">
                {items.map((i) => (
                    <div key={i} className="shimmer shimmer-avatar" />
                ))}
            </div>
        );
    }

    if (type === 'table') {
        return (
            <div className="shimmer-container">
                <div className="shimmer shimmer-table-header" />
                {items.map((i) => (
                    <div key={i} className="shimmer shimmer-table-row" />
                ))}
            </div>
        );
    }

    return null;
};
